import {createFileRoute} from "@tanstack/react-router"
import {useClaimGetQuery} from "@/api/endpoints/claim"
import {useTranslation} from "react-i18next"
import {clsx} from "@/utils/clsx"
import {Title} from "@/components/ui/Title/Title"
import styles from "./index.module.scss"
import stylesCommon from '@/common/commonStyles.module.scss'
import {Button} from "@/components/ui/Button/Button"
import {formatRemaining} from "@/utils/formatRemaining"
import {useGetCurrentMonthQuery} from "@/api/endpoints/other.ts"
import {useAppKitAccount} from "@reown/appkit/react"
import {useUserPools} from "@/context/UserPoolsContext.tsx"
import {useEffect} from "react"
import {loadAllData} from "@/redux/poolThunks.ts"
import {useAppDispatch} from "@/common/hooks.ts"
import {MyActiveProducts} from "@/components/home/MyActiveProducts/MyActiveProducts.tsx"
import {useSelector} from "react-redux"
import {userIsHasInvest, userIsInGrowPool, userIsInStablePool} from "@/redux/selectors.ts"
import {RevsharePools} from "@/components/WelcomeDashboard/RevsharePools/RevsharePools.tsx";
import {DashboardElements} from "@/components/WelcomeDashboard/DashboardElements/DashboardElements.tsx";
import {DashboardNsCards} from "@/components/WelcomeDashboard/DashboardNSCards/DashboardNSCards.tsx";
import {DashboardPartners} from "@/components/WelcomeDashboard/DashboardPartners/DashboardPartners.tsx";
import {DashboardPhotos} from "@/components/WelcomeDashboard/DashboardPhotos/DashboardPhotos.tsx";
import {useAuthQuery} from "@/hooks/useAuthApi.ts";

export const Route = createFileRoute("/_mainLayout/")({
  component: RouteComponent,
})

function RouteComponent() {
  // return <></>

  const {t} = useTranslation("claim")
  const jwt = localStorage.getItem("joinToken")
  const {data: claim} = useAuthQuery(useClaimGetQuery, jwt ? {join: jwt} : { join:undefined} )

  const {data: currentMonthUtc} = useGetCurrentMonthQuery()
  const {address} = useAppKitAccount()
  const {getAllPoolsState, getAllUserPools} = useUserPools()

  const dispatch = useAppDispatch()

  const isUserInStablePool = useSelector(userIsInStablePool)
  const isUserInGrowPool = useSelector(userIsInGrowPool)
  const isUserIsHasInvest = useSelector(userIsHasInvest)

  // console.log(isUserInStablePool, isUserInGrowPool,isUserIsHasInvest)

  useEffect(() => {
    if (!currentMonthUtc && !address) {
      return
    }
    dispatch(loadAllData({
      currentMonthUtc,
      address,
      getAllUserPools,
      getAllPoolsState
    }))


  }, [currentMonthUtc, address, getAllUserPools])

  return (
    <div className={clsx(stylesCommon.centerContainer, styles.centerContainer)}>
      {!!claim?.znx_amount && (<div className={stylesCommon.innerStartContainer}>
         <div className={clsx(styles.row)}>
            <div className={clsx(styles.claim)}>
              <div className={clsx(styles.text)}>{t("have")}</div>
              <Title variant="green" className={clsx(styles.title)}>
                {claim?.znx_amount} {t("ZNX")}
              </Title>
              <div className={clsx(styles.text)}>{t("available")}</div>

              <div className={clsx(styles.description)}>{t("description")}</div>
              <Button
                href="/claim"
                variant="primary"
                className={clsx(styles.button)}
              >
                {t("button")}
              </Button>
              {claim?.expire_at && (
                <div className={clsx(styles.expired)}>
                  {formatRemaining(
                    claim?.expire_at || new Date().toLocaleDateString(),
                  )}
                </div>
              )}
            </div>
          {(isUserIsHasInvest) && <MyActiveProducts/>}
        </div>
      </div> )}
      <RevsharePools isConnected />
      <div className={styles.containerParallax}>
        <DashboardElements isConnected/>
      </div>
      <DashboardNsCards isConnected/>
      <DashboardPartners />
      <DashboardPhotos />
    </div>
  )
}
